import { render, staticRenderFns } from "./DataBuildContactAllocationCampaigns.vue?vue&type=template&id=11768fb8&scoped=true"
import script from "./DataBuildContactAllocationCampaigns.vue?vue&type=script&lang=js"
export * from "./DataBuildContactAllocationCampaigns.vue?vue&type=script&lang=js"
import style0 from "./DataBuildContactAllocationCampaigns.vue?vue&type=style&index=0&id=11768fb8&prod&scoped=true&lang=css"
import style1 from "./DataBuildContactAllocationCampaigns.vue?vue&type=style&index=1&id=11768fb8&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11768fb8",
  null
  
)

export default component.exports